// removed by extract-text-webpack-plugin
module.exports = {"nav":"nav--3UDPT","nav-item":"nav-item--3cR3o","is-active":"is-active--2n20R","display":"display--xyksv","modal-trigger":"modal-trigger--2y92E","modal-inner":"modal-inner--18-DD","close-wrapper":"close-wrapper--1fQYl","close":"close--2p93c","image-wrapper":"image-wrapper--37nyN","full-img":"full-img--uP1fS"};


//////////////////
// WEBPACK FOOTER
// ./client/components/graph-display/graph-display.scss
// module id = 485
// module chunks = 0